import { useSendCommand } from '@/_core/cqrs/use';
import { Action } from '@/_core/fluxstore/types';
import { SaveViewOptions } from '../../../api/commands';
import { StorymapState, ViewType } from '../../types';
import { currentViewOptions } from '../../use';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class SetShouldShowAnnotationBlock extends Action<StorymapState> {
    public static ACTION_TYPE = 'SetShouldShowAnnotationBlock';

    public constructor(public isEnabled: boolean) {
        super(SetShouldShowAnnotationBlock.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: SetShouldShowAnnotationBlock): Promise<boolean> => {
    useSendCommand(action, {
        createCommand: () =>
            new SaveViewOptions(
                state.id,
                state.currentViewType,
                currentViewOptions.value.isShowPrioritization,
                action.isEnabled,
                currentViewOptions.value.isShowPersonaBlock,
                currentViewOptions.value.isShowIssueType,
                currentViewOptions.value.isShowAssignee
            ),
    });

    return true;
};

const reducer = (state: StorymapState, action: SetShouldShowAnnotationBlock): void => {
    if (state.currentViewType === ViewType.Discovery) {
        state.discoveryViewOptions.isShowAnnotation = action.isEnabled;
    }

    if (state.currentViewType === ViewType.Planning) {
        state.planningViewOptions.isShowAnnotation = action.isEnabled;
    }

    if (state.currentViewType === ViewType.Backlog) {
        state.backlogViewOptions.isShowAnnotation = action.isEnabled;
    }
};

//@ts-ignore
registerMiddleware(SetShouldShowAnnotationBlock.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(SetShouldShowAnnotationBlock.ACTION_TYPE, reducer);
